<template>
  <div id="app">
    <router-view />
    <LoginModal :visible="loginVisible" @close="loginVisible = false" @success="handleLoginSuccess" @notice="showToast" />
    <MiniProgramModal :visible="miniProgramVisible" @close="miniProgramVisible = false" />
    <CustomerService />
    <MobileBottomNav v-if="$route.path !== '/wechat-auth'" />
    <transition name="app-toast-fade">
      <div v-if="toast" class="app-toast" :class="`is-${toastType}`" role="status" aria-live="polite">
        <span class="app-toast-icon" aria-hidden="true">{{ toastIcon }}</span>
        <span class="app-toast-text">{{ toast }}</span>
      </div>
    </transition>
  </div>
</template>

<script>
import LoginModal from './components/LoginModal.vue'
import CustomerService from './components/CustomerService.vue'
import MiniProgramModal from './components/MiniProgramModal.vue'
import MobileBottomNav from './components/MobileBottomNav.vue'
import { getPcBalance } from './api/sysMember'
import { completeLogin, isLoggedIn, setLoginPromptHandler, setUserProfile } from './utils/auth'
import { isWechatBrowser, startWechatOauth } from './utils/wechatOauth'

export default {
  name: 'App',
  components: { LoginModal, CustomerService, MiniProgramModal, MobileBottomNav },
  data() {
    return {
      loginVisible: false,
      miniProgramVisible: false,
      toast: '',
      toastType: 'info',
      toastTimer: null
    }
  },
  computed: {
    toastIcon() {
      return { success: '✓', warning: '!', error: '×', info: 'i' }[this.toastType]
    }
  },
  created() {
    setLoginPromptHandler(() => {
      if (isWechatBrowser()) {
        startWechatOauth(this.$route.fullPath, true)
      } else {
        this.loginVisible = true
      }
    })
    window.addEventListener('paper-toast', this.handleToast)
    window.addEventListener('paper-mini-program', this.handleMiniProgram)
    if (isLoggedIn()) this.refreshBalance()
  },
  beforeDestroy() {
    window.removeEventListener('paper-toast', this.handleToast)
    window.removeEventListener('paper-mini-program', this.handleMiniProgram)
    window.clearTimeout(this.toastTimer)
  },
  methods: {
    async handleLoginSuccess({ token, user }) {
      completeLogin(user, token)
      this.loginVisible = false
      await this.refreshBalance()
      this.showToast('微信登录成功，可以继续提交订单')
    },
    async refreshBalance() {
      try {
        const response = await getPcBalance()
        const data = response.data || {}
        if (data.balance !== undefined && data.balance !== null) {
          setUserProfile({ balance: data.balance })
        }
      } catch (error) {
        // 页面会保留登录用户资料，但不把本地默认余额当成真实余额。
      }
    },
    handleToast(event) {
      this.showToast(event.detail || '操作成功')
    },
    handleMiniProgram() {
      this.miniProgramVisible = true
    },
    showToast(message) {
      const text = String(message || '操作成功')
      this.toastType = this.resolveToastType(text)
      this.toast = text
      window.clearTimeout(this.toastTimer)
      this.toastTimer = window.setTimeout(() => {
        this.toast = ''
      }, 2200)
    },
    resolveToastType(message) {
      if (/失败|错误|异常|不能|不足|不可用|过期|不存在|不支持/.test(message)) return 'error'
      if (/请|需|不能为空/.test(message)) return 'warning'
      if (/成功|已取消|已刷新|已选择|已提交|已完成|已到账|已保存|已更新|已退出/.test(message)) return 'success'
      return 'info'
    }
  }
}
</script>
